// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__h4ICj","fullView":"styles_fullView__2O44I"};